

export default class OptionList{
    constructor(){
        this._optionList = [];
        this._selected = [];
        this._parent = null;
    }
    getMaxBuyCount(item){
        let res = [item._stock, item._maxPurchase, this._parent._count, this._parent._maxPurchase];
        res.sort(function(a,b){
            return a-b;
        });
        return res[0];
    }
    setParent(parent){
        this._parent = parent;
    }
    
    init(data){
        if(data.length >0 ){
            this._optionList = data;
        }
    }    
}